const PREFIX = 'MOMNT_CP_';
const LOAN_NUMBER = `${PREFIX}LOAN_NUMBER`;

export function getLoanNumber(): string | null {
  return localStorage.getItem(LOAN_NUMBER);
}

export function setLoanNumber(value: string) {
  return localStorage.setItem(LOAN_NUMBER, value);
}

export function clearStorage() {
  localStorage.removeItem('JWT_TOKEN');
  localStorage.removeItem(LOAN_NUMBER);
}
